export const getters = {
  systemTrucktrackings: state => state.trucktrackings,
  Trucktracking: state => state.systemTrucktracking
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucktrackings/getters.js